const Backofficebff: any = import.meta.env.VITE_BACKOFFICEBFF!;

export const CargoAddressBlockingCommand: any = {
    UpsertBlockedAddress: Backofficebff + '/v1/deliveryservice/upsert-blocked-address',
    DeleteBlockedAddress: Backofficebff + '/v1/deliveryservice/delete-blocked-address',
};
